import { gql } from '@apollo/client';

const GET_VIEWS_LIST = gql`
	query getViews {
		viewLists {
			viewId
			viewName
			viewPreview
			description
			stage
			type
			createdAt
		}
	}
`;
const GET_VIEW_LIST = (viewId) => {
	return gql`
    query getViews{
            viewList(viewId:"${viewId}"){
                viewId
                viewName
                viewPreview
                description
                stage
                type
                squad
                accountName
                createdAt

        }
    }
`;
};

const GET_VIEW_CSS_VARIABLES = (viewId) => {
	return gql`
        query getViewCssVariables{
            viewCssVariables(viewId:"${viewId}"){
                viewId
                cssVariables
            }
        }
    `;
};
const GET_VIEW = (viewId) => {
	return gql`
    query getView{
        view(viewId:"${viewId}"){
            id
            jsonContent
        }
    }`;
};
const GET_STYLE_JSON_VIEW = (viewId) => {
	return gql`
    query viewStyleJson{
        viewStyleJson(viewId:"${viewId}"){
            styleJson
        }
    }`;
};

const GET_RECENT_COMMITS = (viewId, qty = 20) => {
	return gql`
    query getRecentCommits{
        recentCommits(viewId:"${viewId}",qty:${Number(qty)}){
            commitId
            commitDate
            commitValue
            viewId
            userId
            userEmail
            userName
        }
    }
`;
};

const GET_VIEW_IMAGES = (viewId) => {
	return gql`
        query getViewImages{
            getViewImages(viewId:"${viewId}"){
                images
        }
    }`;
};

const GET_MOCK_VIEW_IMAGES = (viewId) => {
	return gql`
        query getMockViewImages{
            getMockViewImages(viewId:"${viewId}"){
                mockImages
        }
    }`;
};

const CREATE_OR_UPDATE_VIEW = gql`
	mutation createView($id: String!, $jsonContent: String!) {
		createView(id: $id, jsonContent: $jsonContent) {
			success
			message
		}
	}
`;
const CREATE_OR_UPDATE_VIEW_LIST_ITEM = gql`
	mutation createView(
		$viewId: String
		$viewName: String!
		$viewPreview: String!
		$description: String
		$stage: String
		$type: String
		$squad: String
		$accountName: String
	) {
		createViewListItem(
			viewId: $viewId
			viewName: $viewName
			viewPreview: $viewPreview
			description: $description
			stage: $stage
			type: $type
			squad: $squad
			accountName: $accountName
		) {
			success
			id
			message
		}
	}
`;
const UPDATE_VIEW_PREVIEW = gql`
	mutation updateViewPreview($viewId: String, $viewPreview: String) {
		updateViewPreview(viewId: $viewId, viewPreview: $viewPreview) {
			success
		}
	}
`;
const DELETE_VIEW_LIST_ITEM = gql`
	mutation deleteView($viewId: String, $userId: String) {
		deleteViewListItem(viewId: $viewId, userId: $userId) {
			success
			id
			message
		}
	}
`;
const CREATE_COMMIT = gql`
	mutation createCommit($commitValue: String, $viewId: String, $userId: String, $userName: String, $userEmail: String) {
		createCommit(
			commitValue: $commitValue
			viewId: $viewId
			userId: $userId
			userEmail: $userEmail
			userName: $userName
		) {
			success
			viewId
			message
		}
	}
`;
const UPDATE_VIEW_CSS_VARIABLES = gql`
	mutation updateViewCssVariables($viewId: String, $cssVariables: String) {
		updateCssVariables(viewId: $viewId, cssVariables: $cssVariables) {
			success
			message
		}
	}
`;
const UPDATE_VIEW_IMAGES = gql`
	mutation updateViewImages($viewId: String, $images: String) {
		updateViewImages(viewId: $viewId, images: $images) {
			success
			id
			message
		}
	}
`;
const UPDATE_VIEW_MOCK_IMAGES = gql`
	mutation updateViewMockImages($viewId: String, $mockImages: String) {
		updateViewMockImages(viewId: $viewId, mockImages: $mockImages) {
			success
			id
			message
		}
	}
`;

const DUPLICATE_VIEW = gql`
	mutation duplicateView($viewId: String) {
		duplicateView(viewId: $viewId) {
			success
			clonedData
			message
		}
	}
`;

export default {
	GET_VIEWS_LIST,
	GET_VIEW,
	CREATE_OR_UPDATE_VIEW,
	CREATE_OR_UPDATE_VIEW_LIST_ITEM,
	GET_VIEW_LIST,
	CREATE_COMMIT,
	GET_RECENT_COMMITS,
	GET_VIEW_IMAGES,
	DELETE_VIEW_LIST_ITEM,
	UPDATE_VIEW_PREVIEW,
	GET_STYLE_JSON_VIEW,
	GET_VIEW_CSS_VARIABLES,
	UPDATE_VIEW_CSS_VARIABLES,
	UPDATE_VIEW_IMAGES,
	GET_MOCK_VIEW_IMAGES,
	UPDATE_VIEW_MOCK_IMAGES,
	DUPLICATE_VIEW,
};
